<template>
  <v-combobox
    v-model="currentLimit"
    :items="possibleLimits"
    :label="$t('pagination.limit')"
    style="max-width: 5rem"
    single-line
    outlined
    dense
    hide-details
  />
</template>
<script>
const { mapMutations } = require('vuex');
export default {
  data: () => ({
    possibleLimits: [25, 50, 100],
    currentLimit: 25
  }),
  props: {
    datatype: {
      type: String,
      required: true
    }
  },
  computed: {
    pagination() {
      return this.$store.state.AdminUserStore.pagination.find((item) => item.datatype === this.datatype);
    },
    limit() {
      return this.$store.state.AdminUserStore.pagination.find((item) => item.datatype === this.datatype)?.limit ?? 25;
    },
    maxLimit() {
      return this.possibleLimits.reduce((max, curr) => (curr > max ? curr : max), 0);
    },
    minLimit() {
      return this.possibleLimits.reduce((min, curr) => (curr < min ? curr : min), this.maxLimit);
    },
    offset() {
      return this.$store.state.AdminUserStore.pagination.find((item) => item.datatype === this.datatype)?.offset ?? 0;
    }
  },
  methods: {
    ...mapMutations({
      setPagination: 'AdminUserStore/setPagination'
    })
  },
  watch: {
    currentLimit: {
      handler(newLimit) {
        this.currentLimit = Math.abs(newLimit);
        if (isNaN(newLimit)) {
          this.currentLimit = this.minLimit;
        } else if (this.currentLimit > this.maxLimit) {
          this.currentLimit = this.maxLimit;
        }
        this.setPagination({
          datatype: this.datatype,
          limit: this.currentLimit,
          offset: 0
        });
      }
    },
    datatype: {
      async handler() {
        this.currentLimit = this.limit;
      },
      immediate: true
    }
  }
};
</script>
